<template>
  <div class="welcome">
    <div class="content">
      <div class="sub-title">欢迎体验</div>
      <div class="title"> 通用后台管理系统</div>
      <div class="desc">
        打造通用后台管理系统
      </div>
    </div>
    <div class="img"></div>
  </div>
</template>

<script>

export default {
  name: 'welcomePage',
  props: [],
  components: {

  },
  data () {
    return {

    }
  },
  // 方法 函数写这里
  methods: {},
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 过滤器
  filters: {},
  // 以下是生命周期
  // 组件创建之前
  beforeCreate () {},
  // 组件创建之后
  created () {},
  // 页面渲染之前
  beforeMount () {},
  // 页面渲染之后
  mounted () {

  },
  // 页面视图数据更新之前
  beforeUpdate () {},
  // 页面视图数据更新之后
  updated () {},
  // 页面销毁之前
  beforeDestroy () {},
  // 页面销毁之后
  destroyed () {}
}
</script>

<style lang="scss"  scoped>
.welcome {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: #fff;
  .content {
    position: relative;
    bottom: 10px;
    .sub-title {
      font-size: 30px;
      line-height: 42px;
      color: #333;
    }
    .title {
      font-size: 40px;
      line-height: 62px;
      color: #409eff;
    }
    .desc {
      text-align: right;
      font-size: 14px;
      color: #999;
    }
  }
  .img {
    margin-left: 105px;
    background-image: url("https://s3.bmp.ovh/imgs/2021/08/0601792d1a8b6476.png");
    width: 371px;
    height: 438px;
  }
}
</style>
